import moment from 'moment';
const sample = {
	rowType: 'add',
	permGrpCd: null,
	userGrpName: null,
	useYn: 'Y',
	useYnBk: 'Y',
	prop1: '',
	prop2: 'sf-12312',
	prop3: '탭샘플이다',
	prop4: 'Y',
	prop5: 'CSPI',
	prop6: '2022-05-05',
	prop7: '32034',
	prop8: 'TS-12OS23',
	prop9: '나기두',
	prop10: '2022-03-02',
	testTime: moment(),
	prop12: 'N',
	prop13: '55',
	prop14: 'N',
	prop15: 'Y',
	prop16: 'Y',
	prop17: '',
	prop18: '',
	prop19: '',
	prop20: ''
};

export default {
	resultList: [sample],
	gridUseYnList: [
		{ label: '미사용', value: 'N' },
		{ label: '사용', value: 'Y' }
	],
	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	},
	prop1: '',
	prop2: '',
	prop3: '',
	prop4: '',
	prop5: '',
	prop6: '',
	prop7: '',
	prop8: '',
	prop9: '',
	prop10: '',
	prop11: '',
	prop12: '',
	prop13: '',
	prop14: '',
	prop15: '',
	prop16: '',
	prop17: '',
	prop18: '',
	prop19: '',
	prop20: ''
};
